import { AbstractControl, ValidationErrors } from "@angular/forms";
import { CustomValidator } from "@serasa/shared/seds";

export class MinMaxLengthRegexValidator extends CustomValidator {

  private key: string;
  private message: string;
  private regex: RegExp;

  constructor(min: number, max: number, key: string, message: string) {
    super();
    this.key = key;
    this.message = message;
    this.regex = new RegExp(`^.{${min},${max}}$`);
  }

  protected isValid(control: AbstractControl): boolean {
    if (this.regex.test(control.value) ) {
      return true;
    }

    return false;
  }

  protected errorValidator(): ValidationErrors {
    return {
      [this.key]: this.message
    };
  }
}
